import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { Container, Row, Col, Tabs, Tab, Nav } from "react-bootstrap"
import Slider from "react-slick";
import ScrollAnimation from 'react-animate-on-scroll';
import dateFormat from 'dateformat';
import PlayVideo from '../../../components/Play/PlayVideo';
import {youtube_parser, CustomLinks} from "../../common/utils";
import {ImageModule} from "../../../modules/Image_Module"
import {FeatureInsights} from "../../../queries/common_use_query"
import "../../Home/News/News"
// Header component

const Employees_Say = (props) => {
    const [isPlay, setPlay] = useState(false);
    const [videoId, setVideoId] = useState('');

    const settings = {
        dots: false,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: false,
        arrows: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    infinite: false,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },

            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };


    //console.log("props_Module", props.Module)
    return (
        <React.Fragment>
            <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                {
                    props.Module && 
                    <section className={`news-section employee_say`}>
                    <Container>
                        <Row>
                            <Col className="news-content">
                                <div className="news-heading">
                                    <h2>{props.Module.Title}</h2>
                                </div>

                                {
                                    <Tab.Container defaultActiveKey={"0"}>
                                            
                                        <Tab.Content>
                                            <Tab.Pane eventKey={"0"}>
                                            {props.Module.Employee_Say_Module && props.Module.Employee_Say_Module.length > 0 && 
                                                <Slider {...settings}>
                                                {
                                                    props.Module.Employee_Say_Module.map((item, index) => {

                                                        var youtube_id = item.Embed_Video_Link && youtube_parser(item.Embed_Video_Link);
                                                        return(
                                                            <div className="news-wrapper">
                                                                
                                                                <div className="news-img img-zoom">
                                                                    <picture>
                                                                        {item.Upload_Image && 
                                                                            <ImageModule ImageSrc={item?.Upload_Image[0]} altText={item?.Upload_Image[0]?.alternativeText ? item?.Upload_Image[0]?.alternativeText : props.Module.Title + " - Strettons"} ggfx_results={props?.ggfx_results} strapi_id={props?.articleId} imagename="articles.Employee_Say_Module.image"  />                                           
                                                                        }
                                                                    </picture>
                                                                    {
                                                                        item.Embed_Video_Link && 
                                                                        <div className="video-buttons center-icon" onClick={(e) => { setVideoId(youtube_id);  setPlay(true) }}>
                                                                            <strong className="video-btn">
                                                                                <i className="icon-video-black"></i>
                                                                            </strong>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                
                                                                <div className="news-details">
                                                                    <h2>{item.Name}</h2>
                                                                    <h5>{item.Position}</h5>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }                                       
                                                </Slider>
                                            }
                                            </Tab.Pane>
                                        </Tab.Content>
                                </Tab.Container>
                                }
                            </Col>
                        </Row>
                    </Container>
                    </section>
                }
                

            </ScrollAnimation>
            
            <PlayVideo
                isOpen={isPlay}
                isCloseFunction={setPlay}
                videoId={videoId}
                isAutoPlay={1}
            />
        </React.Fragment>
    )
}
export default Employees_Say
